import { useQuery, gql } from "@apollo/client";
import { ASSET_FRAGMENT, BODY_CONTENT_FRAGMENT, ADDITIONAL_INFO_CONTENT_FRAGMENT } from "./fragments";

export const HandleQuery = (query_state) =>
{
    const { loading, error, data } = query_state;
    if (loading) return { complete: false, view: <p></p> };
    if (error) return { complete: false, view: <p>Query error: {error.message}</p> };
    if (!data) return { complete: false, view: <p>Data error: no data!</p> };
    return { complete: true, view: <></> };
};

export const HomeData = gql`
    query Home3 {
      home: homeEntry {
        id
        sectionHandle
        carousel {
          ... on slide_Entry {
            id
            navText
            linkText
            linkText2
            subhead
            head
            customUrl
            customUrl2
            image {
              ...AssetFragment
            }
            relatedEntry {
              id
              uri
            }
            relatedEntry2 {
              id
              uri
            }
          }
        }
        alert
        homeWhatWeDoTitle
        homeWhatWeDoSlogan
        homeWhatWeDoIntro
        homeWhatWeDoEntries {
          id
          uri
          ... on whatWeDo_Entry {
            displayTitle
            title
            summary
            featureImage {
              ...AssetFragment
            }
          }
        }
        homeOurPurposeTitle
        homePageOurPurposeSlogan
        homeOurPurposeSummary
        homePageOurPurposeImage {
          ...AssetFragment
        }
        homePageOurPurposeEntries {
          id
          uri
          ... on projects_Entry {
            displayTitle
            title
            summary
            featureImage {
              ...AssetFragment
            }
          }
        }
        homeJoinOurTeamHeading
        homePageJoinOurTeamSlogan
        homePageJoinOurTeamText
        homePageJoinOurTeamImage {
          ...AssetFragment
        }
        homePageJoinOurTeamLinkText1
        homePageJoinOurTeamLinkUrl1
        homePageJoinOurTeamLinkText2
        homePageJoinOurTeamLinkUrl2
      }
      projectPosts: pageEntries(id: "17675") {
        ... on page_Entry {
          bodyContent {
            ... on relatedProjects_Entry {
              id
              project {
                ... on projects_Entry {
                  displayTitle
                  title
                  summary
                  featureImage {
                    ...AssetFragment
                  }
                  uri
                }
              }
            }
          }
        }
      }
      relatedTeamMembersVideos: pageEntries(id: "24484") {
        ... on page_Entry {
          bodyContent {
            ... on relatedTeamMembersVideos_Entry {
              id
              featuredTeamMembers {
                ... on staff_Entry {
                  displayTitle
                  slug
                  position
                  featureImage {
                    ...AssetFragment
                  }
                  staffCareersVideo {
                    title
                    url
                    aspectRatio
                  }
                }
              }
            }
          }
        }
      }
      newsPosts: newsEntries(orderBy: "postDate DESC", limit: 4) {
        ... on news_Entry {
          id
          title
          displayTitle
          slug
          uri
          postDate
          summary
          featureImage {
            ...AssetFragment
          }
        }
      }
      whatWeDoPosts: whatWeDoEntries(orderBy: "postDate DESC", limit: 20) {
        ... on whatWeDo_Entry {
          title
          displayTitle
          slug
          uri
          postDate
          summary
          featureImage {
            ...AssetFragment
          }
        }
      }
    }
    ${ASSET_FRAGMENT}
`;

export const EntryData = (slug) =>
{
    return(gql`
        query EntryData {
            site: globalSets {
                ... on socialMedia_GlobalSet {
                    twitterHandle
                }
                ... on globals_GlobalSet {
                    siteDescription
                    siteImage {
                        ...AssetFragment
                    }
                }
            }
            entries(slug: "${slug}")
            {
                metaTitle
                displayTitle
                title
                metaImage {
                    ...AssetFragment
                }
                featureImage {
                    ...AssetFragment
                }
                metaDescription
                summary
                metaKeywords
            }
        }

        ${ASSET_FRAGMENT}
    `);
}

export const PageData = (slug) => 
{
    return(gql`
  query PageEntryQuery {
  entry: pageEntries(slug: "${slug}") {
    ... on page_Entry {
      displayTitle
      id
      sectionHandle
      featureImage {
        ...AssetFragment
      }
      showFeatureImage
      title
      postDate
      customNavLogo {
        ...AssetFragment
      }
      carousel {
        ... on slide_Entry {
          id
          navText
          linkText
          linkText2
          subhead
          head
          customUrl
          customUrl2
          image {
            ...AssetFragment
          }
          relatedEntry {
            id
            uri
          }
          relatedEntry2 {
            id
            uri
          }
        }
      }
      bodyContent {
        ...BodyContentFragment
      }
      featureImage {
        url
      }
    }
  }
  relatedFeedNews: newsEntries(
    relatedToEntries: {slug: "${slug}"}
  ) {
    ... on news_Entry {
      sectionHandle
      displayTitle
      slug
      uri
      postDate
      summary
      featureImage {
        ...AssetFragment
      }
    }
  }
  relatedFeedNewsletters: newslettersEntries(
    relatedToEntries: {slug: "${slug}"}
  ) {
    ... on newsletters_Entry {
      sectionHandle
      uri
      displayTitle
      summary
      postDate
      newsletterLink
      downloads {
        url
        size
        kind
      }
      featureImage {
        ...AssetFragment
      }
    }
  }
  relatedFeedReportsAndOtherDocuments: resourcesEntries(
    relatedToEntries: {slug: "${slug}"}
  ) {
    ... on resources_Entry {
      sectionHandle
      displayTitle
      uri
      postDate
      summary
      featureImage {
        ...AssetFragment
      }
    }
  }
}
    ${BODY_CONTENT_FRAGMENT}
    ${ASSET_FRAGMENT}

`)
    };

export const NavLinksData = gql`
    query {
      links: mainEntries(orderBy: "lft") {
        ... on entryLink_Entry {
          title
          linkUrl
          entry {
            uri
          }
          level
          parent {
            id
          }
          id
        }
      }
    }`;

export const SslnDocumentsData = gql`
    query SSLNDocumentsComponentQuery {
  items: sslnDocumentsEntries(orderBy: "postDate DESC") {
    ... on sslnDocuments_Entry {
      title
      featureImage {
        ...AssetFragment
      }
      file {
        url
        title
        mimeType
      }
      sslnLink
      sslnVideoLink {
        title
        url
        aspectRatio
      }
      sslnDocumentType
      sslnCountry
      hivPreventionPillar
    }
  }
}
    ${ASSET_FRAGMENT}
  `;

export const LatestProjectData = gql`
query {
  posts: projectsEntries(limit: 3) {
    ... on projects_Entry {
      title
      displayTitle
      slug
      uri
      postDate
      summary
      featureImage {
        ...AssetFragment
      }
    }
  }
}
    ${ASSET_FRAGMENT}
         `;

export const WhatWeDoOverviewData = (slug) => {
    return(gql`
  query WhatWeDoEntryQuery {
  entry: whatWeDoEntries(slug: "${slug}") {
    id
    sectionHandle
    title
    summary
    featureImage {
      ...AssetFragment
    }
    whatWeDoFeatureVideo {
      title
      url
      aspectRatio
    }
    whatWeDoFeatureBrochure {
      url
      title
      size
      height
      kind
      width
    }
    whatWeDoBrochureLink
    whatWeDoBrochureAspectRatio
    whatWeDoFeatureBrochure2 {
      url
      title
      size
      height
      kind
      width
    }
    whatWeDoBrochureLink2
    whatWeDoBrochureAspectRatio2
    bodyContent {
      ...BodyContentFragment
    }
    useReadMore
    whatWeDoAdditionalInfo {
      ...AdditionalInfoContentFragment
    }
    relatedAreasOfExpertiseFocusAreas {
      ... on whatWeDo_Entry {
        displayTitle
        summary
        uri
        featureImage {
          ...AssetFragment
        }
      }
    }
    relatedAreasOfExpertise {
      ... on areaOfExpertise_Entry {
        slug
        title
        uri
      }
    }
    relatedProjects {
      ... on projects_Entry {
        title
        summary
        uri
        featureImage {
          ...AssetFragment
        }
      }
    }
    relatedTeamMembers {
      ... on staff_Entry {
        slug
      }
    }
    teamLeads {
      ... on staff_Entry {
        id
        title
        displayTitle
        position
        status
        sectionId
        sectionHandle
        slug
        uri
        featureImage {
          ...AssetFragment
        }
        bodyContent {
          ...BodyContentFragment
        }
      }
    }
    relatedFocusArea {
      ... on whatWeDo_Entry {
        displayTitle
        summary
        uri
        featureImage {
          ...AssetFragment
        }
      }
    }
    showCustomBanner
    customBannerHeadline
    customBannerRichText
    customBannerImage {
      ...AssetFragment
    }
    customBannerLink
    secondaryBannerImage {
      ...AssetFragment
    }
    secondarybannerlink
  }
  relatedFocusAreaProjects: projectsEntries(
    relatedToEntries: {slug: "${slug}"}
    orderBy: "postDate DESC"
  ) {
    ... on projects_Entry {
      id
    }
  }
  relatedAreaOfExpertiseProjects: projectsEntries(
    relatedToEntries: {slug: "${slug}"}
    orderBy: "postDate DESC"
  ) {
    ... on projects_Entry {
      id
    }
  }
}
    ${BODY_CONTENT_FRAGMENT}
    ${ASSET_FRAGMENT}
    ${ADDITIONAL_INFO_CONTENT_FRAGMENT}
`);
};

export const WhatWeDoAreasOfExpertiseData = (slug) => 
{
    return(gql`
  query WhatWeDoAreasOfExpertiseEntryQuery {
  entry: whatWeDoEntries(slug: "${slug}") {
    ... on whatWeDo_Entry {
      id
      title
      summary
      relatedAreasOfExpertiseFocusAreas {
        ... on whatWeDo_Entry {
          displayTitle
          summary
          uri
          featureImage {
            ...AssetFragment
          }
        }
      }
      relatedAreasOfExpertise {
        ... on areaOfExpertise_Entry {
          slug
          title
          uri
          summary
          bodyContent {
            ...BodyContentFragment
          }
        }
      }
      relatedProjects {
        ... on projects_Entry {
          id
        }
      }
      relatedFocusArea {
        ... on whatWeDo_Entry {
          id
        }
      }
      relatedTeamMembers {
        ... on staff_Entry {
          slug
        }
      }
    }
  }
  relatedFocusAreaProjects: projectsEntries(
    relatedToEntries: {slug: "$slug"},
    orderBy: "postDate DESC"
  ) {
    ... on projects_Entry {
      id
    }
  }
  relatedAreaOfExpertiseProjects: projectsEntries(
    relatedToEntries: {slug: "${slug}"},
    orderBy: "postDate DESC"
  ) {
    ... on projects_Entry {
      id
    }
  }
}

    ${BODY_CONTENT_FRAGMENT}
    ${ASSET_FRAGMENT}

`);
};

export const WhatWeDoFocusAreasData = (slug) => 
{
    return(gql`
  
  query WhatWeDoFocuAreasEntryQuery {
  entry: whatWeDoEntries(slug: "${slug}") {
    ... on whatWeDo_Entry {
      title
      relatedAreasOfExpertiseFocusAreas {
        ... on whatWeDo_Entry {
          id
        }
      }
      relatedAreasOfExpertise {
        ... on areaOfExpertise_Entry {
          id
        }
      }
      relatedProjects {
        ... on projects_Entry {
          id
        }
      }
      relatedFocusArea {
        ... on whatWeDo_Entry {
          displayTitle
          summary
          uri
          featureImage {
            ...AssetFragment
          }
        }
      }
      relatedTeamMembers {
        ... on staff_Entry {
          slug
        }
      }
    }
  }
  relatedFocusAreaProjects: projectsEntries(
    relatedToEntries: {slug: "${slug}"},
    orderBy: "postDate DESC"
  ) {
    ... on projects_Entry {
      id
    }
  }
  relatedAreaOfExpertiseProjects: projectsEntries(
    relatedToEntries: {slug: "${slug}"},
    orderBy: "postDate DESC"
  ) {
    ... on projects_Entry {
      id
    }
  }
}

    ${ASSET_FRAGMENT}
`);
};


export const WhatWeDoProjectsData = (slug) => {
    return(gql`
  
query WhatWeDoProjectsEntryQuery {
  entry: whatWeDoEntries(slug: "${slug}") {
    ... on whatWeDo_Entry {
      id
      title
      relatedAreasOfExpertiseFocusAreas {
        ... on whatWeDo_Entry {
          id
        }
      }
      relatedAreasOfExpertise {
        ... on areaOfExpertise_Entry {
          id
        }
      }
      relatedProjects {
        ... on projects_Entry {
          displayTitle
          title
          summary
          uri
          featureImage {
            ...AssetFragment
          }
        }
      }
      relatedFocusArea {
        ... on whatWeDo_Entry {
          id
        }
      }
      relatedTeamMembers {
        ... on staff_Entry {
          slug
        }
      }
    }
  }
  relatedFocusAreaProjects: projectsEntries(
    relatedToEntries: {slug: "${slug}"},
    orderBy: "postDate DESC"
  ) {
    ... on projects_Entry {
      id
      displayTitle
      title
      summary
      uri
      postDate
      featureImage {
        ...AssetFragment
      }
    }
  }
  relatedAreaOfExpertiseProjects: projectsEntries(
    relatedToEntries: {slug: "${slug}"},
    orderBy: "postDate DESC"
  ) {
    ... on projects_Entry {
      id
      displayTitle
      title
      summary
      uri
      postDate
      featureImage {
        ...AssetFragment
      }
    }
  }
}
    ${ASSET_FRAGMENT}
`);
};


export const WhatWeDoTeamData = (slug) =>
{
    return(gql`
  
  query WhatWeDoTeamEntryQuery {
  entry: whatWeDoEntries(slug: "${slug}") {
    ... on whatWeDo_Entry {
      title
      relatedAreasOfExpertiseFocusAreas {
        ... on whatWeDo_Entry {
          id
        }
      }
      relatedAreasOfExpertise {
        ... on areaOfExpertise_Entry {
          id
        }
      }
      relatedProjects {
        ... on projects_Entry {
          id
        }
      }
      relatedFocusArea {
        ... on whatWeDo_Entry {
          id
        }
      }
      relatedTeamMembers {
        ... on staff_Entry {
          displayTitle
          status
          uri
          position
          featureImage {
            ...AssetFragment
          }
          bodyContent {
            ...BodyContentFragment
          }
        }
      }
    }
  }
  relatedFocusAreaProjects: projectsEntries(
    relatedToEntries: {slug: "${slug}"}
    orderBy: "postDate DESC"
  ) {
    ... on projects_Entry {
      id
    }
  }
  relatedAreaOfExpertiseProjects: projectsEntries(
    relatedToEntries: {slug: "${slug}"}
    orderBy: "postDate DESC"
  ) {
    ... on projects_Entry {
      id
    }
  }
}

    ${BODY_CONTENT_FRAGMENT}
    ${ASSET_FRAGMENT}
`);
};

export const NewsListingData = (limit, skip) => {
    return(gql`
  query NewsPostsQuery {
  entry: newsIndexEntry {
    ... on newsIndex_Entry {
      title
      displayTitle
      summary
    }
  }
  news: newsEntries(orderBy: "postDate DESC", limit: ${limit}, offset: ${skip}) {
    ... on news_Entry {
      displayTitle
      slug
      uri
      postDate
      summary
      featureImage {
        ...AssetFragment
      }
    }
  }
  all: newsEntries {
    ... on news_Entry {
        id
    }
  }
}
    ${ASSET_FRAGMENT}
`);
};

export const NewsData = (slug) => {
    return(gql`
  query NewsPostQuery {
  entry: newsEntries(slug: "${slug}") {
    ... on news_Entry {
      id
      sectionHandle
      displayTitle
      url
      uri
      postDate
      byline
      newsCategory {
        ... on newsCategory_Entry {
          id
          title
        }
      }
      featureImage {
        ...AssetFragment
      }
      bodyContent {
        ...BodyContentFragment
      }
    }
  }
}

    ${BODY_CONTENT_FRAGMENT}
    ${ASSET_FRAGMENT}
`);
}

export const NewsletterListingData = (limit, skip) => 
{
    return(gql`
  query NewlettersQuery {
  newsletters: newslettersEntries(
    orderBy: "postDate DESC"
    limit: ${limit}
    offset: ${skip}
  ) {
    ... on newsletters_Entry {
      uri
      displayTitle
      summary
      newsletterLink
      downloads {
        url
        size
        kind
      }
      featureImage {
        ...AssetFragment
      }
    }
  }
  all: newslettersEntries {
    ... on newsletters_Entry {
      id
    }
  }
}
  ${ASSET_FRAGMENT}
`);
}


export const NewslettersEntryData = (slug) => 
{
    return(gql`
  query NewsLetterEntryQuery {
  entry: newslettersEntries(slug: "${slug}") {
    ... on newsletters_Entry {
      displayTitle
      summary
      url
      uri
      sectionHandle
      newsletterLink
      postDate
      downloads {
        url
        size
        kind
      }
      featureImage {
        ...AssetFragment
      }
    }
  }
}
  ${ASSET_FRAGMENT}
`);
};

export const ResourceListingData = (limit, skip) => {
    return(gql`
  query ResourcesQuery {
  resources: resourcesEntries(
    orderBy: "postDate DESC",
    limit: ${limit},
    offset: ${skip}
  ) {
    ... on resources_Entry {
      displayTitle
      uri
      summary
      featureImage {
        ...AssetFragment
      }
    }
  }
  all: resourcesEntries {
    ... on resources_Entry {
        id 
    }
  }
}
${ASSET_FRAGMENT}
`);
};

export const ResourceEntryData = (slug) => 
{
    return(gql`
  query ResourceEntryQuery {
  entry: resourcesEntries(slug: "${slug}") {
    ... on resources_Entry {
      id
      sectionHandle
      title
      postDate
      url
      uri
      summary
      bodyContent {
        ...BodyContentFragment
      }
      featureImage {
        ...AssetFragment
      }
      file {
        url
        title
        size
        height
        kind
        width
      }
    }
  }
}
${BODY_CONTENT_FRAGMENT}
${ASSET_FRAGMENT}
`);
}

export const StaffListingData = (limit, skip) => {
    return( gql`
  query StaffQuery {
  staff: staffEntries(orderBy: "postDate DESC", limit: ${limit}, offset: ${skip}) {
    ... on staff_Entry {
      title
      displayTitle
      position
      slug
      uri
      featureImage {
        ...AssetFragment
      }
      bodyContent {
        ...BodyContentFragment
      }
    }
  }
 all: staffEntries {
    ... on staff_Entry {
        id
    }
  }
}
  ${BODY_CONTENT_FRAGMENT}
  ${ASSET_FRAGMENT}
`);
};

export const StaffEntryData = (slug) => {
    return(gql`
  query StaffEntryQuery {
  entry: staffEntries(slug: "${slug}") {
    ... on staff_Entry {
      id
      title
      position
      email
      linkedinProfileUrl
      sectionId
      sectionHandle
      slug
      featureImage {
        ...AssetFragment
      }
      bodyContent {
        ...BodyContentFragment
      }
    }
  }
}
${BODY_CONTENT_FRAGMENT}
${ASSET_FRAGMENT}
`);
};

export const ProjectListingData = (limit, skip) => {
    return(gql`
  query ProjectsListingQuery {
  posts: projectsEntries(
    orderBy: "postDate DESC",
    limit: ${limit},
    offset: ${skip}
  ) {
    ... on projects_Entry {
      title
      displayTitle
      slug
      uri
      postDate
      summary
      featureImage {
        ...AssetFragment
      }
    }
  }
  all: projectsEntries {
    ... on projects_Entry {
      id
    }
  }
  entry: projectsIndexEntry {
    ... on projectsIndex_Entry {
      title
      displayTitle
      summary
    }
  }
}
${ASSET_FRAGMENT}
`);
};

export const ProjectEntryData = (slug) => {
    return(gql`
  query ProjectsEntryQuery {
  entry: projectsEntries(slug: "${slug}") {
    ... on projects_Entry {
      id
      title
      url
      uri
      summary
      displayTitle
      sectionHandle
      projectDate
      countries
      clientName
      relatedAreaOfExpertise {
        title
      }
      relatedFocusArea {
        title
      }
      featureImage {
        ...AssetFragment
      }
      bodyContent {
        ...BodyContentFragment
      }
    }
  }
}
${BODY_CONTENT_FRAGMENT}
${ASSET_FRAGMENT}
`);
};

export const GalleryEntryData = (slug) => {
    return( gql`
 query GalleryEntryQuery {
  entry: galleriesEntries(slug: "${slug}") {
    ... on galleries_Entry {
      id
      title
      url
      uri
      displayTitle
      sectionHandle
      featureImage {
        ...AssetFragment
      }
      galleryImages {
        ...AssetFragment
      }
    }
  }
}
${ASSET_FRAGMENT}
`);
};

export const SeoData = gql`
  query SEO {
  site: globalSets {
    ... on socialMedia_GlobalSet {
      twitterHandle
    }
    ... on globals_GlobalSet {
      siteDescription
      siteImage {
        ...AssetFragment
      }
    }
  }
}
${ASSET_FRAGMENT}
`;
